var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    staticClass: "goods-tabs"
  }, [_c('v-col', {
    staticClass: "ma-n4",
    attrs: {
      "cols": "12",
      "lg": "6",
      "order-lg": "1"
    }
  }, [_c('v-tabs', {
    attrs: {
      "hide-slider": "",
      "show-arrows": false
    },
    model: {
      value: _vm.tab,
      callback: function ($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, _vm._l(_vm.items, function (item, index) {
    return _c('v-tab', {
      key: index
    }, [_c('div', {
      staticClass: "goods-tabs__title"
    }, [_vm._v(" " + _vm._s(item.title) + " ")])]);
  }), 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('v-tabs-items', {
    model: {
      value: _vm.tab,
      callback: function ($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, _vm._l(_vm.items, function (item, index) {
    return _c('v-tab-item', {
      key: index,
      attrs: {
        "eager": ""
      }
    }, [_c('div', {
      staticClass: "border-radius-16 overflow-hidden"
    }, [_c('v-img', {
      attrs: {
        "src": item.image,
        "eager": "",
        "alt": ""
      }
    })], 1)]);
  }), 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }